@use '@design/design-tokens/border-radius/border-radius' as *;

.tooltip {
  @include border-radius-r2;
  padding: 8px;
  min-width: 275px;
  background-color: var(--surface-active);

  [data-tooltip-arrow] {
    background-color: var(--surface-active);
  }
}

.bubble {
  display: flex;
  align-items: center;
  gap: 8px;
}
